import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail } from "lucide-react";
import { categories } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-[hsl(20,14%,12%)] text-white/80 mt-20">
      {/* Newsletter */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h3 className="font-serif text-2xl md:text-3xl text-white mb-2">
              Junta-te ao clube RADIX
            </h3>
            <p className="text-sm text-white/60">
              Subscreve e recebe 10% de desconto na primeira compra + acesso antecipado a novidades.
            </p>
          </div>
          <form
            onSubmit={(e) => e.preventDefault()}
            className="flex gap-2 w-full max-w-md md:ml-auto"
          >
            <div className="flex-1 flex items-center bg-white/10 rounded-full px-4 h-12">
              <Mail className="h-4 w-4 text-white/50" />
              <input
                type="email"
                required
                placeholder="O teu email"
                className="flex-1 bg-transparent outline-none px-3 text-sm text-white placeholder:text-white/40"
              />
            </div>
            <button
              type="submit"
              className="bg-primary hover:bg-[hsl(12,62%,52%)] text-primary-foreground font-medium px-6 rounded-full transition-colors"
            >
              Subscrever
            </button>
          </form>
        </div>
      </div>

      {/* Links */}
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div>
          <span className="font-serif text-2xl tracking-[0.2em] text-white">RADIX</span>
          <p className="text-sm text-white/50 mt-4 leading-relaxed">
            Beauty-tech premium para o teu ritual diário. Dispositivos que elevam a tua pele e cabelo, entregues à tua porta.
          </p>
          <div className="flex gap-3 mt-5">
            {[Instagram, Facebook, Youtube].map((Icon, i) => (
              <a
                key={i}
                href="#"
                className="h-9 w-9 rounded-full bg-white/10 hover:bg-primary flex items-center justify-center transition-colors"
              >
                <Icon className="h-4 w-4 text-white" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-white font-medium mb-4 text-sm">Comprar</h4>
          <ul className="space-y-2 text-sm">
            {categories.map((c) => (
              <li key={c.id}>
                <Link to={`/loja/${c.slug}`} className="hover:text-white transition-colors">
                  {c.name}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/loja" className="hover:text-white transition-colors">Saldos</Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-medium mb-4 text-sm">Ajuda</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/envios" className="hover:text-white transition-colors">Envios & Entregas</Link></li>
            <li><Link to="/reembolsos" className="hover:text-white transition-colors">Devoluções & Reembolsos</Link></li>
            {["Contactos", "FAQ", "Rastrear encomenda"].map((l) => (
              <li key={l}>
                <a href="#" className="hover:text-white transition-colors">{l}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-medium mb-4 text-sm">Empresa</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/quem-somos" className="hover:text-white transition-colors">Quem Somos</Link></li>
            {["Blog de beleza", "Programa de afiliados", "Termos & Condições", "Privacidade"].map((l) => (
              <li key={l}>
                <a href="#" className="hover:text-white transition-colors">{l}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <p>© {new Date().getFullYear()} RADIX Beauty. Todos os direitos reservados.</p>
          <div className="flex items-center gap-3">
            <span>Visa</span>
            <span>Mastercard</span>
            <span>PayPal</span>
            <span>MB Way</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
